var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navs"},[_c('router-link',{attrs:{"to":"/homepage"}},[_vm._v("HOME")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/garment"}},[_vm._v("GARMENT")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/fabric"}},[_vm._v("FABRIC")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6a1ce68","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation.vue
// module id = null
// module chunks = 